const TOUR_COMPLETED_VERSION = 'welcomeToT2CV2';

const normalizeEmail = (email?: string): string => (email || '').trim().toLowerCase();

const getTourUserPrefix = (email?: string): string => normalizeEmail(email).slice(0, 4);

export const getTourUserEmail = (userData: any): string => {
  return normalizeEmail(userData?.email || userData?.user?.email || userData?.profile?.email);
};

export const getTourStorageKey = (baseKey: string, email?: string): string => {
  const userPrefix = getTourUserPrefix(email);

  if (!userPrefix) {
    return baseKey;
  }

  return `${baseKey}_${userPrefix}`;
};

export const getTourCompletedVersion = (email?: string): string => {
  const userPrefix = getTourUserPrefix(email);

  if (!userPrefix) {
    return TOUR_COMPLETED_VERSION;
  }

  return `${userPrefix}_${TOUR_COMPLETED_VERSION}`;
};

export const isTourCompletedForUser = (welcomeToT2C: string, email?: string): boolean => {
  return welcomeToT2C === getTourCompletedVersion(email);
};
